var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 88C68.9727 88 88 68.9727 88 45.5C88 22.0273 68.9727 3 45.5 3C22.0273 3 3 22.0273 3 45.5C3 68.9727 22.0273 88 45.5 88Z",
    stroke: "url(#paint0_linear_5298_38095)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 46L38.3333 62L69 30",
    stroke: "url(#paint1_linear_5298_38095)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5298_38095",
    x1: 3,
    y1: 3,
    x2: 88,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C79EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#863CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5298_38095",
    x1: 23,
    y1: 30,
    x2: 53.0025,
    y2: 73.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C79EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#863CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.ceebeac6738479565272f7c005b90c38.svg";
export { ForwardRef as ReactComponent };